import { AnyAction, Reducer } from 'redux';
import {
  ACTION, RequestLinks, ReceiveLinks, FailedLinks
} from './action-types';
import { LinksSectionState } from './types-store';

export const INITIAL_STATE: LinksSectionState = {
  linksGroups: undefined,
  fetchingLinksGroups: false
};

export const reducers: ActionMap = {
  [ACTION.REQUEST_LINKS]: (state: LinksSectionState, action: RequestLinks): LinksSectionState => {
    return {
      ...state,
      fetchingLinksGroups: true
    };
  },

  [ACTION.RECEIVE_LINKS]: (state: LinksSectionState, action: ReceiveLinks): LinksSectionState => {
    return {
      ...state,
      linksGroups: action.linksGroups,
      fetchingLinksGroups: false
    };
  },

  [ACTION.FAIL_LINKS]: (state: LinksSectionState, action: FailedLinks): LinksSectionState => {
    return {
      ...state,
      fetchingLinksGroups: false
    };
  }
};

export const reducer: Reducer<LinksSectionState> = (state: LinksSectionState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};

interface ActionMap {
  [indexer: string]: Reducer<LinksSectionState>;
}
